<template>
  <div :class="$style.container">
    <h2 :class="$style.title">複製の確認</h2>
    <div>
      <p>{{ sourcePlanner.name }}の自動応答チャットメッセージを</p>
      <ul>
        <li v-for="(destination, index) in destinations" :key="index">
          {{ destination.text }}
        </li>
      </ul>
      <p>
        に複製します<br />
        よろしいですか？
      </p>
    </div>
    <section :class="$style.buttonSection">
      <FlatButton @click="handleCancel" variant="secondary"
        >キャンセル</FlatButton
      >
      <FlatButton @click="handleConfirm">保存</FlatButton>
    </section>
  </div>
</template>

<script setup lang="ts">
import FlatButton from '@/components/atoms/FlatButton.vue'
import { type AutoChatReplyCopyConfirmationModalPlannerFragment } from './AnswerMessageAutoChatReplyCopyConfirmationModal.generated'

defineProps<{
  sourcePlanner: AutoChatReplyCopyConfirmationModalPlannerFragment
  destinations: {
    value: string
    text: string
    isDisabled: boolean
  }[]
}>()

const emit = defineEmits<{
  (event: 'cancel'): void
  (event: 'confirm'): void
}>()

const handleCancel = () => {
  emit('cancel')
}

const handleConfirm = () => {
  emit('confirm')
}
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
  gap: 22px;
  padding: 16px 28px;
}

.title {
  font-size: 20px;
  font-weight: 700;
}

.buttonSection {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}
</style>
